export class RecipePermission {
    public RecipeId: number;
    public Permission: string;
    public UserGroup: string;
    public Operator: string;
    public Groups: string;
}
